import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from '../../css/RegisterPage.module.css';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    userRole: '',
    university: null,
    isStudent: false,
    recentGraduate: false,
  });

  const [universities, setUniversities] = useState([]); // List of universities
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  // Fetch registered universities from the backend
  useEffect(() => {
    fetchUniversities();
  }, []);

  const fetchUniversities = async () => {
    try {
      const response = await axios.get(
        'https://techservicemarket-backend.onrender.com/api/users/register/universities'
      );
      setUniversities(response.data); // Assuming the backend sends an array of university names
    } catch (err) {
      console.error('Error fetching universities:', err);
      setError('Failed to load universities');
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        'https://techservicemarket-backend.onrender.com/api/users/register',
        formData
      );
      navigate('/dashboard');
      setSuccessMessage(response.data.message); // Success message from backend
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong!');
      setSuccessMessage('');
    }
  };

  return (
    <div className={styles.registerContainer}>
      <h2 className={styles.registerHeader}>Register</h2>
      {error && <div className={styles.errorMessage}>{error}</div>}
      {successMessage && <div className={styles.successMessage}>{successMessage}</div>}
      <form onSubmit={handleSubmit} className={styles.registerForm}>
        <input
          type="text"
          name="username"
          placeholder="Username"
          value={formData.username}
          onChange={handleChange}
          required
          minLength="3"
          className={styles.inputField}
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
          className={styles.inputField}
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
          className={styles.inputField}
        />
        <input
          type="text"
          name="firstName"
          placeholder="First Name"
          value={formData.firstName}
          onChange={handleChange}
          required
          minLength="2"
          className={styles.inputField}
        />
        <input
          type="text"
          name="lastName"
          placeholder="Last Name"
          value={formData.lastName}
          onChange={handleChange}
          required
          minLength="2"
          className={styles.inputField}
        />
        <div className={styles.checkboxContainer}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="recentGraduate"
              checked={formData.recentGraduate}
              onChange={handleChange}
              className={styles.checkboxInput}
            />
            Have you graduated from a university in the last 2 years?
          </label>
        </div>
        {formData.recentGraduate && (
          <div className={styles.selectContainer}>
            <label htmlFor="university" className={styles.selectLabel}>
              Select Your University:
            </label>
            <select
              name="university"
              value={formData.university}
              onChange={handleChange}
              required
              className={styles.selectInput}
            >
              <option value="">-- Select University --</option>
              {universities.map((university) => (
                <option key={university._id} value={university._id}>
                  {university.universityName} {/* Display the university name */}
                </option>
              ))}
            </select>
          </div>
        )}
        <button type="submit" className={styles.submitButton}>
          Register
        </button>
      </form>
    </div>
  );
};

export default Register;
